import { render, staticRenderFns } from "./retenidos.vue?vue&type=template&id=45f3ccf9"
import script from "./retenidos.vue?vue&type=script&lang=js"
export * from "./retenidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports